import React from 'react';
import { Popup } from 'react-leaflet';
import './MarkerPopup.scss';
import { PopupContent } from '../PopupContent';

export const MarkerPopup = (props) => {
  const { lat, lng, properties, onClose } = props;

  if (lat && lng) {
    const commonPopupProps = {
      className: 'MarkerPopup-li__popup',
      offset: { x: 0, y: -45 },
      position: { lat, lng },
    };

    return (
      <Popup {...commonPopupProps} onClose={onClose}>
        <div className={`MarkerPopup-li__popup-wrap`}>
          <PopupContent onClose={onClose} properties={properties} />
        </div>
      </Popup>
    );
  }

  return null;

};
